import { EVENTS } from '../events';

/**
 * Feedback plugin
 */
export class FeedbackPlugin {

	constructor(chat) {
		this.chat = chat;
	}

	init() {
		if (this.chat.options.is_admin) {
			this.chat.on(EVENTS.WSCHAT_ON_RENDER_USER_META, info => this.update_user_meta(info));
			return true;
		}

		const picker = jQuery(BTN_TEMPLATE);

		this.chat.$el.find('.attachment-wrapper .attachment-list').append(picker);

		picker.click(() => this.show_picker());

        this.chat.$el.on('click', '#wschat_email_feedback_form_close', e => this.remove_form(e))

		this.chat.$el.on('click', '.feedback-action', e => this.submit_form(e));

		this.chat.on(EVENTS.WSCHAT_ON_SET_CONVERSATION, () => this.update_ui());
	}

	update_user_meta(meta_element) {
		const feedback_element = jQuery(ADMIN_PREVIEWER_CONTENT);
		const feedback = this.chat.get_conversation_meta('user_feedback');

		if (feedback !== false) {
			feedback_element.find('.alert').addClass('d-none');
			feedback_element.find('.alert.'+feedback).removeClass('d-none');
		}

		meta_element.append(feedback_element);
	}

	update_ui() {
		const feedback = this.chat.get_conversation_meta('user_feedback');

		if (feedback !== false) {
			jQuery('#wschat_feedback_picker').find('i').text(feedback);
		}
	}

	submit_form(e) {
		const btn = jQuery(e.target);
		const data = {
			action: this.ACTION_FEEDBACK,
			feedback: btn.data('action'),
		};

		this.chat.update_conversation_meta('user_feedback', data.feedback);
		this.update_ui();

		const frm = btn.parents('.wschat_feedback_form_popup');

		btn.prop('disabled', true);

		jQuery.post(this.chat.options.api.endpoint, data, (res) => {
			frm.html(res.data.msg);

			setTimeout(() => {
				frm.remove();
			}, 3000);
		}).done(() => {
			btn.prop('disabled', false).append('sd');
		});
	}

	remove_form(e) {
    	e && e.preventDefault();
		this.chat.$el.find('.wschat_feedback_form_popup').remove();
	}

	show_picker() {
		const file_input = jQuery(CONFIRM_EMAIL_TEMPLATE);

		this.remove_form();
		this.chat.$el.find('.chat-panel').after(file_input);
	}

}

FeedbackPlugin.prototype.ACTION_FEEDBACK = 'wschat_coversation_feedback';

export const BTN_TEMPLATE = `
	<button id="wschat_feedback_picker" class="btn btn-sm attachment-list-item" title="Feedback">
		<i class="material-icons align-bottom">thumbs_up_down</i>
	</button>
`;

export const CONFIRM_EMAIL_TEMPLATE = `
    <div class=" wschat_feedback_form_popup p-3 ">
    	<div class="row ">
            <label for="feedback_field_email" class="col form-label form-label-sm text-center">Give us a your valuable feedback</label>
        	<button class="btn btn-sm col-auto" id="wschat_email_feedback_form_close" type="button"><i class="material-icons align-bottom">close</i></button>
    	</div>
    	<div class="row">
            <div class="col d-flex justify-content-around mt-2">
                <button class="btn btn-sm btn-secondary feedback-action " data-action="thumb_down" type="button"><i class="material-icons align-bottom">thumb_down</i> Bad</button>
                <button class="btn btn-sm btn-primary feedback-action " data-action="thumb_up" type="button"><i class="material-icons align-bottom">thumb_up</i> Good</button>
            </div>
        </div>
    </div>
`;

const ADMIN_PREVIEWER_CONTENT = `
	<div class="row mb-2">
		<div class=" text-center ">
			<div class="alert alert-light">No feedback yet</div>
			<div class="alert alert-success thumb_up d-none">User liked the chat</div>
			<div class="alert alert-danger thumb_down d-none">User disliked the chat</div>
		</div>
	</div>
`
